import '../shared/nav/collapsing_nav'
import '../shared/phone'
import './roomcash_amount_update'
import HotelSearch from '../shared/roomcash_hotel_search'
import AddToCartForms from '../shared/add_to_cart_forms'
import HotelIndex from '../shared/add_to_cart_forms/h4h_hotels/hotel_index'

import Checkout from '../shared/checkout'
import DepositRedemptions from '../shared/deposit_redemptions'
import CartNav from '../shared/nav/nav_cart'
import MobileNavActions from './mobile-nav-clicks'
import CopyButton from './copy_button'
import SignUp from '../default/customers/signup'
import { store } from'../default/store'
import VueLoader from '../default/vue-loader'
import '../default/reservations/reservation'
import '../shared/buyers_page_personalizer'

document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  DepositRedemptions.findCustomerDeposits()
  Checkout.loadWithAddOn()
  MobileNavActions.loadNavDropdown()
  CopyButton.load()
  VueLoader.loadVueComponent(SignUp, document.getElementById('signupForm'), store)
  VueLoader.loadVueComponent(HotelSearch, document.getElementById('hotel_searches'), store)
  VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)

})
